import React, { useState, useEffect } from 'react';
import './NotificationLoginComponent.css';
import successIcon from '../Assets/Svg/check-circle.svg';
import errorIcon from '../Assets/Svg/check-circle-error.svg';
import { GetAllEvents } from '../Backend/ApiCalls';

export const Notification = ({ message, type, show }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(show);
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [show]);

  return (
    <div className={`notification ${isVisible ? 'show' : ''}`}>
      <div className="notification__body">
        <img
          src={type === 'success' ? successIcon : errorIcon}
          alt={type === 'success' ? 'Success' : 'Error'}
          className="notification__icon"
          style={type === 'success' ? {} : { color: '#494949' }}
        />
        <span style={type === 'success' ? {} : { color: 'var(--error2)' }}>{message}</span>
      </div>
      <div
        className="notification__progress"
        style={
          type === 'success'
            ? {}
            : { background: 'linear-gradient(to right, var(--notification-background), var(--error2))' }
        }
      ></div>
    </div>
  );
};
